import { Checkbox } from '@liveauctioneers/hammer-ui-core/checkbox';
import { BodySecondary, Caption, H5, H6 } from '@liveauctioneers/hammer-ui-core/text';
import { useCallback } from 'react';

import useWindowSize from '@/hooks/useWindowSize';
import { useAppDispatch } from '@/redux/hooks';
import { toggleEmailListSubscription } from '@/redux/modules/account/notifications/emailList/emailList.actions';
import { UNSUBSCRIBE_TO_ALL_EMAIL_LISTS } from '@/redux/modules/account/notifications/emailList/emailList.types';
import { mergedCaterwaulAndHammerUIThemes } from '@/theme/mergedCaterwaulAndHammerUIThemes';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

import { TableRow } from './TableRow';

type Props = {
    code: string;
    description: string;
    frequency: string;
    name: string;
    subscribed: boolean;
};

export const NotificationRow = ({ code, description, frequency, name, subscribed }: Props) => {
    const formatMessage = useAppFormatMessage();
    const dispatch = useAppDispatch();
    const frequencyText = frequency === 'Real Time' ? 'Real-Time' : frequency;
    const toggleEmail = useCallback(() => {
        dispatch(toggleEmailListSubscription({ code }));
    }, [code, dispatch]);

    const { width } = useWindowSize();
    const {
        breakpoints: { tabletNarrowWidthNum },
    } = mergedCaterwaulAndHammerUIThemes;

    if (code === UNSUBSCRIBE_TO_ALL_EMAIL_LISTS) {
        return null;
    }

    return (
        <TableRow
            className="smMax:[&>:nth-child(1)]:grid-cols-[1/5]"
            email={
                <Checkbox.Option
                    aria-label={String(
                        formatMessage(['notificationsPage', 'toggleEmailNotifications'], {
                            values: {
                                name,
                            },
                        })
                    )}
                    checked={subscribed}
                    className="mb-0"
                    name="emailCheckbox"
                    onChange={toggleEmail}
                />
            }
            frequency={width > tabletNarrowWidthNum && <BodySecondary>{frequencyText}</BodySecondary>}
            type={
                <>
                    {width > tabletNarrowWidthNum ? <H5>{name}</H5> : <H6>{name}</H6>}
                    {width <= tabletNarrowWidthNum ? (
                        <Caption>{description}</Caption>
                    ) : (
                        <BodySecondary color="secondary">{description}</BodySecondary>
                    )}
                </>
            }
        />
    );
};
